import {
  CreateOrderData,
  AmountBreakdown,
  OrderItem as OrderItemPayPal,
} from '@wix/cashier-core/dist/src/services/PayPal/types';
import { PaymentBreakdown } from '../../types/PaymentBreakdown';
import { ShippingContact } from '../../types/Shipping';
import { PayPalShippingAddress } from '../../types/paypal';
import { OrderItem } from '../../types/OrderItem';

export interface OrderData {
  paymentAmount: string;
  paymentBreakdown: PaymentBreakdown;
  orderItems: OrderItem[];
  currencyCode: string;
  requestShipping: boolean;
}

/**
 * Transforms data to backend-compatible structure
 * @param data
 */
export function transformOrderDataToPayPal(data: OrderData): CreateOrderData {
  return {
    totalAmount: Number(data.paymentAmount),
    currency: data.currencyCode,
    amountBreakdown: transformPaymentBreakdownToPayPal(data.paymentBreakdown),
    orderItems: transformOrderItemsToPayPal(data.orderItems),
    requestShipping: data.requestShipping,
  };
}

export function transformPaymentBreakdownToPayPal(paymentBreakdown: PaymentBreakdown): AmountBreakdown {
  if (!paymentBreakdown) {
    return null;
  }

  return Object.entries(paymentBreakdown).reduce((acc, [key, value]: any) => {
    acc[key] = Number(value);
    return acc;
  }, {}) as AmountBreakdown;
}

export function transformOrderItemsToPayPal(orderItems: OrderItem[] = []): OrderItemPayPal[] {
  return orderItems.map((item) => ({
    ...item,
    price: Number(item.price),
    // https://jira.wixpress.com/browse/PAY-1652
    category: undefined,
  }));
}

export const transformToShippingContact = (data: PayPalShippingAddress): ShippingContact => {
  return {
    countryCode: data.country_code,
    city: data.city,
    postalCode: data.postal_code,
    state: data.state,
  };
};
